var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tabs',{staticStyle:{"margin-top":"30px"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:0,attrs:{"ripple":""}},[_vm._v("\n      Dividas\n    ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n      Acordos\n    ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab-item',{key:1},[_c('Dividas')],1),_vm._v(" "),_c('v-tab-item',{key:2},[_c('Acordos')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./src/pages/relatorios/Relatorio.html?vue&type=template&id=67096966&scoped=true&
// module id = 509
// module chunks = 1